import { useEffect, useState } from 'react';

export const useDebounce = (value: string, timeout = 600): string => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, timeout);
        return () => {
            clearTimeout(handler);
        };
    }, [value, timeout]);
    return debouncedValue;
};
